import { LwApiPM } from "@techniaorg/liteweb-api";
import { waitForIFrameAndModel } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrameAndModel(myframe)
  .then((api) => {
    LwAPI = api;
    LwAPI.registerOnSelection((selectedItem) => {
      console.log("onSelection", selectedItem);
      if (selectedItem.item == null) {
        selectionId = null;
      } else {
        selectionId =
          selectedItem.item.modelId + ":" + selectedItem.item.modelItemId;
      }
    });
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

let selectionId: string | null = null;

// Apply color to the current selection
function ex_applyColor(rgba: [number, number, number, number]) {
  if (selectionId != null) {
    LwAPI?.setColor(selectionId, rgba);
  }
}

// Reset color for the current selection
function ex_resetColor() {
  if (selectionId != null) LwAPI?.resetColor(selectionId);
}

// Reset all colors
function ex_resetAllColor() {
  LwAPI?.resetColor();
}

// Bind functions to buttons
document.getElementById("darkRedButton")?.addEventListener("click", async () => {
  await apiReady;
  ex_applyColor([139, 0, 0, 255]);
});
document
  .getElementById("forestGreenButton")
  ?.addEventListener("click", async () => {
    await apiReady;
    ex_applyColor([34, 139, 34, 255]);
  });
document.getElementById("goldButton")?.addEventListener("click", async () => {
  await apiReady;
  ex_applyColor([255, 215, 0, 255]);
});
document
  .getElementById("steelBlueButton")
  ?.addEventListener("click", async () => {
    await apiReady;
    ex_applyColor([70, 130, 180, 255]);
  });
document
  .getElementById("limeTransparentButton")
  ?.addEventListener("click", async () => {
    await apiReady;
    ex_applyColor([0, 255, 0, 82]);
  });
document
  .getElementById("resetColorButton")
  ?.addEventListener("click", async () => {
    await apiReady;
    ex_resetColor();
  });
document
  .getElementById("resetAllColorButton")
  ?.addEventListener("click", async () => {
    await apiReady;
    ex_resetAllColor();
  });
